<template>
  <v-dialog
    :value="value"
    @input="$emit('input')"
    max-width="1000px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card class="ims-modal-card safe-zone-preview-card">
      <v-toolbar dense flat class="ims-modal-header">
        <v-toolbar-title class="font-weight-bold">Preview of safe zones</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon aria-label="Close" @click="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid class="ims-modal-body safe-zone-preview-body">
        <v-row class="safe-zone-preview-options">
          <v-col class="pa-0 d-flex flex-wrap justify-center" cols="12">
            <v-switch
              class="mr-5"
              v-model="isIGCutOff"
              label="Preview IG Reel"
              @change="changeCutOff('IG')"
            ></v-switch>
            <v-switch
              class="mr-5"
              v-model="isIGStory"
              label="Preview IG Story"
              @change="changeCutOff('IGStory')"
            ></v-switch>
            <v-switch
              class=""
              v-model="isTikTokCutOff"
              label="Preview Tiktok"
              @change="changeCutOff('tiktok')"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row class="safe-zone-preview-media">
          <v-col
            v-for="(media, index) of postData.media"
            :key="index"
            cols="12"
            sm="6"
            md="4"
          >
            <custom-media-v2
              :media="campaignHelper.customPostMediaConfig(media, {overlay: true, overlayType, creatorView: true, postView: true})"
            />
            <btn-download
              v-if="!media.preview.thumbnail"
              :url="media.preview.src"
            ></btn-download>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="ims-modal-actions safe-zone-preview-actions">
        <v-spacer></v-spacer>
        <v-btn text @click="closeModal">Cancel</v-btn>
        <v-btn color="primary" depressed @click="confirm">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex';
import SocialHandle from '@/components/scoped/custom/SocialHandle';
import campaignHelper from '../Campaign/campaignHelper';
import CustomMediaV2 from '../../scoped/custom/CustomMediaV2';
export default {
  name: 'PostMediaPreviewModal',
  props: [
    'value',
    'selectedCampaign',
    'postData'
  ],
  components: {
    SocialHandle,
    CustomMediaV2
  },
  data() {
    return {
      isIGCutOff: false,
      isIGStory: false,
      isTikTokCutOff: false,
      campaignHelper
    }
  },
  computed: {
    ...mapState(['user', 'activePlatform', 'showActivePlatform']),
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    currentUserID() {
      return this.$store.state.user.id
    },
    currentUser() {
      return this.$store.state.user
    },
    currentUserFullName() {
      return `${this.$store.state.user.firstName} ${this.$store.state.user.lastName}`
    },
    overlayType() {
      if (this.isIGCutOff) {
        return 'IG'
      }
      if (this.isIGStory) {
        return 'IGStory'
      }
      if (this.isTikTokCutOff) {
        return 'TikTok'
      }
    }
  },
  methods: {
    changeCutOff(type) {
      if (type === 'IG' && this.isIGCutOff) {
        this.isIGCutOff = true
        this.isIGStory = false
        this.isTikTokCutOff = false
      } else if (type === 'IGStory' && this.isIGStory) {
        this.isIGCutOff = false
        this.isIGStory = true
        this.isTikTokCutOff = false
      } else if (type === 'tiktok' && this.isTikTokCutOff) {
        this.isIGCutOff = false
        this.isIGStory = false
        this.isTikTokCutOff = true
      } else {
        this.isIGCutOff = false
        this.isIGStory = false
        this.isTikTokCutOff = false
      }
    },
    confirm() {
      this.$emit('confirmed', true)
      this.closeModal()
    },
    closeModal() {
      this.$emit('input')
    }
  }
}
</script>

<style scoped>
.safe-zone-preview-card {
  height: min(90vh, 820px);
}

.safe-zone-preview-body {
  padding: 16px 24px 24px;
}

.safe-zone-preview-options {
  margin: 0 0 8px;
}

.safe-zone-preview-media {
  margin: 0 -12px;
  align-items: flex-start;
  justify-content: center;
}

.safe-zone-preview-actions {
  min-height: 56px;
  padding: 8px 16px;
}

@media (max-width: 599px) {
  .safe-zone-preview-card {
    height: 100vh;
  }

  .safe-zone-preview-body {
    padding: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// PostMediaPreviewModal.vue?3e22fa4d